import i18n from '@/utils/i18n';
import React, { useEffect, useState } from 'react';
import { AttachmentListHTMLDisplay } from './attachment-list-html-display';
import { createStyles } from '@/contexts/theme-context';
import { Text } from 'react-native';
import { TYPOGRAPHY } from '@/styles';

interface Props {
  htmlURL: string;
  maxHeight?: number;
  onHighlightElementSelect?: (searchInputUUID: string) => void;
  selectedSearchInputUUID?: string;
  showHighlights?: boolean;
  width: number;
  zoomLevel?: number;
}

export const AttachmentListHTML: React.FC<Props> = ({
  htmlURL,
  maxHeight,
  onHighlightElementSelect,
  selectedSearchInputUUID,
  showHighlights,
  width,
  zoomLevel = 1,
}) => {
  const [htmlContent, setHTMLContent] = useState<string | null>(null);
  const [hasError, setHasError] = useState(false);
  const [styles] = useStyles();

  useEffect(() => {
    const fetchAndSetHTMLContent = async () => {
      try {
        const response = await fetch(htmlURL);
        if (!response.ok) {
          throw new Error(`HTTP error fetching HTML: ${response.status}`);
        }

        const contentType = response.headers.get('content-type');
        if (!contentType || !contentType.includes('text/html')) {
          throw new Error(
            `Invalid content for HTML attachment: ${contentType}`,
          );
        }

        const html = await response.text();
        setHTMLContent(html);
      } catch (e) {
        setHasError(true);
      }
    };
    fetchAndSetHTMLContent();
  }, [htmlURL]);

  if (hasError) {
    return (
      <Text style={[TYPOGRAPHY.small, styles.errorText]}>
        {i18n.t('toast.standard_error')}
      </Text>
    );
  }

  if (!htmlContent) {
    return null;
  }

  return (
    <AttachmentListHTMLDisplay
      htmlContent={htmlContent}
      maxHeight={maxHeight}
      onHighlightElementSelect={onHighlightElementSelect}
      selectedSearchInputUUID={selectedSearchInputUUID}
      showHighlights={showHighlights}
      width={width}
      zoomLevel={zoomLevel}
    />
  );
};

const useStyles = createStyles((theme) => ({
  errorText: {
    color: theme.sk.color.text.error,
  },
}));
